import { Campaign } from '@shared/types/mylounge';
import { CategoryTabIds } from '@shared/constants';
import { CampaignWithLeavingSoonFlag } from './types';

export const LEAVING_SOON_LABEL_MAX_CAMPAIGNS = 5;
export const LEAVING_SOON_VIEW_HREF = `/event/${CategoryTabIds.LEAVING_SOON}`;
/**
 * Checks if a campaign is ending today based on its end date
 * @param endsAt - Campaign end date in ISO string format
 * @returns true if the campaign ends today, false otherwise
 */
export const isCampaignEndingToday = (endsAt: string): boolean => {
    const campaignEndDate = new Date(endsAt);
    const todayStart = new Date();
    todayStart.setUTCHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setUTCHours(24, 0, 0, 0);

    return campaignEndDate >= todayStart && campaignEndDate <= todayEnd;
};

/**
 * Filters campaigns to only include those ending today
 * @param campaigns - Array of campaigns to filter
 * @returns Array of campaigns that end today
 */
export const filterCampaignsEndingToday = (campaigns: Campaign[]): Campaign[] =>
    campaigns.filter(campaign => isCampaignEndingToday(campaign.endsAt));

export const enrichWithLeavingSoonFlag = (campaigns: Campaign[]): CampaignWithLeavingSoonFlag[] =>
    campaigns.slice(0, LEAVING_SOON_LABEL_MAX_CAMPAIGNS).map(campaign => ({
        ...campaign,
        hasLeavingSoonFlag: true,
    }));
